<template>
    <div class="dot-nav text-center mb-2">
        <div class="dot-nav-container">
            <div
                v-for="route in routes"
                class="dot-nav-element"
                :class="{
                    active: route.name === $router.currentRoute.name,
                }"
            >
                <div class="dot-navigation-link"></div>
            </div>
        </div>
    </div>
</template>

<style>
.dot-nav-container {
    list-style: none;
    margin: 0;
}

.dot-nav-element {
    background: none repeat scroll 0 0 #cccccc;
    border: 1px solid #aaaaaa;
    border-radius: 15px 15px 15px 15px;
    height: 12px;
    margin: 10px 10px 0px 0px;
    width: 12px;
    display: inline-block;
}

.dot-nav-element.active {
    background-color: #ffffff;
    background-image: -moz-linear-gradient(center top, #ffffff, #eeeeee);
    background-repeat: repeat-x;
}

/*.dot-nav-element:hover {*/
/*    background: none repeat scroll 0 0 #eeeeee;*/
/*}*/
.dot-nav-element .dot-navigation-link {
    outline: 0;
    vertical-align: top;
    margin: 0px 0px 0px 25px;
    position: relative;
    top: -5px;
}
</style>

<script>
import { userQuestionnaireModalRoute } from '../../user_questionnaire/router';
import { globalLogger } from '../../../../../qaamgo/helper/global-logger';
import { pageNotification } from '../../../../../qaamgo/helper/notify';

export default {
    name: 'DotNavigation',
    data() {
        return {
            routes: this.$router.options.routes,
        };
    },
    methods: {
        onBackButtonClick() {
            try {
                this.$router.back();
            } catch (e) {
                globalLogger.log('ProjectUsageForm - back button fail', e);

                pageNotification.showGenericErrorMessage();
            }
        },
    },
};
</script>
